import { useState } from 'react'

const FAQS = [
  {
    q: 'Do I need any real estate experience to use REILM?',
    a: 'No. REILM guides you through each step of the analysis, making it easy to evaluate deals regardless of your experience level.',
  },
  {
    q: 'Why is REILM better than spreadsheets?',
    a: 'Spreadsheets are flexible, but they require manual updates and organization. REILM automates calculations, keeps every deal organized, and brings your analysis into one place.',
  },
  {
    q: 'What does REILM replace?',
    a: 'REILM replaces the spreadsheets, calculators, notes, and disconnected tools many investors use to analyze and manage deals. Everything stays organized in one place from initial analysis to closing.',
  },
  {
    q: 'Can I customize my assumptions?',
    a: 'Yes. REILM allows you to customize the assumptions used in your analysis to match your investment strategy and local market.',
  },
  {
    q: 'How accurate are the projections?',
    a: 'REILM generates projections using the data and assumptions you provide. While no projection can predict future market conditions, REILM helps you evaluate deals using consistent calculations and transparent assumptions.',
  },
]

const Icon = ({ open }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M4 10h12" />
    {!open && <path d="M10 4v12" />}
  </svg>
)

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0)

  const toggle = (i) => setOpenIndex((current) => (current === i ? -1 : i))

  return (
    <section id="faq" className="bg-[#EEFBE7]">
      {/* 14.08 followup, Mobile 1: 60px below the whole section on mobile (was 40) — space
          before CallToAction, not the internal item gaps (those are M1.1/M1.2, unchanged).
          Desktop untouched, he specified mobile only. */}
      <div className="max-w-canvas mx-auto px-6 md:px-[120px] pt-[40px] md:pt-[64px] pb-[60px] md:pb-[72px] flex flex-col md:flex-row justify-between gap-8 md:gap-12">
        <h2 className="w-full md:w-[352px] text-[28px] md:text-[36px] leading-[36px] md:leading-[48px] font-extrabold text-brand-dark md:shrink-0">
          Common Questions,<br />
          <span className="text-brand-primary">Clear Answers</span>
        </h2>

        <div className="w-full md:w-[732px] flex flex-col">
          {FAQS.map(({ q, a }, i) => {
            // D1.1.1-new: the first question sat 24px lower than the heading beside it, because
            // every row carries the same vertical padding. Dropped on the first row from md
            // up, where the two columns are actually side by side.
            const isOpen = openIndex === i
            return (
              <div key={q} className="border-b border-[#a7c199] py-6 md:first:pt-0 flex flex-col gap-4">
                <button
                  type="button"
                  onClick={() => toggle(i)}
                  aria-expanded={isOpen}
                  className={`flex items-center justify-between text-left ${
                    isOpen ? 'text-brand-green' : 'text-brand-dark'
                  }`}
                >
                  <span className="text-[20px] leading-[32px] font-bold">{q}</span>
                  <Icon open={isOpen} />
                </button>
                {isOpen && (
                  <p className="text-[16px] leading-[28px] text-brand-dark">{a}</p>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Faq
